module.exports = __webpack_public_path__ + "img/leaf4.d841315e.png";